import * as React from "react";
import { SVGProps } from "react";
export function GreenBulbIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={30}
      height={30}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#green-bulb_svg__a)"
        stroke="#308238"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10.992 16.563a2.656 2.656 0 1 0 0-5.313 2.656 2.656 0 0 0 0 5.313ZM5.75 24.255c.01-.888.244-1.76.681-2.533a5.302 5.302 0 0 1 4.565-2.67 5.302 5.302 0 0 1 4.564 2.67c.438.773.672 1.645.681 2.533M19.125 6.976V5.804M23.125 8.415l.96-.674M15.123 8.415l-.959-.674M22.034 12.226c.006-1.61-1.358-2.95-2.968-2.917-1.61.033-2.917 1.429-2.844 3.038a2.953 2.953 0 0 0 1.608 2.471v1.429a.324.324 0 0 0 .324.316h1.944a.324.324 0 0 0 .324-.316v-1.454a2.956 2.956 0 0 0 1.611-2.567Z" />
      </g>
      <defs>
        <clipPath id="green-bulb_svg__a">
          <path fill="#fff" transform="translate(5 5)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
